import { useAuth0 } from '@auth0/auth0-react'
import { Navigate, useLocation } from 'react-router-dom'
import { type ReactNode } from 'react'
import { useSyncAuthToStore } from './useSyncAuthToStore'
import { useStore } from '~/state/useStore'
import { ROUTES } from '~/constants/routes'
import type { Auth0Role } from '~/config/auth'

interface Props {
  children: ReactNode
  requireRole?: Auth0Role
}

export function PrivateRoute({ children, requireRole }: Props) {
  useSyncAuthToStore()
  const { isLoading, isAuthenticated } = useAuth0()
  const user = useStore((s) => s.auth.user)
  const location = useLocation()

  if (isLoading) return <div>Loading…</div>
  if (!isAuthenticated) {
    return (
      <Navigate
        to={ROUTES.login}
        state={{ returnTo: location.pathname + location.search }}
        replace
      />
    )
  }
  // SDK is authenticated; bridge hook may still be populating the store on first render.
  if (!user) return <div>Loading…</div>
  if (requireRole && user.role !== requireRole) {
    return <Navigate to={ROUTES.home} replace />
  }
  return <>{children}</>
}
